<!-- CC: extracted from integrations.component.html -> GSuite popup section -->
<div class="flex-column f-1-0 overflow-auto gap-4" *ngIf="planInfo">

	<!--Connect section-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;" [ngClass]="isConnected() ? 'text-success' : 'text-warning'">{{isConnected() ? 'Connected' : 'Disconnected'}}</span>
			<span style="font-size: 12px; max-width: 300px;">{{isConnected() ? 'Your mail server is now integrated with ' + gs.corpname : 'Allow us to establish a secure connection to your Google Workspace using admin-credentials.'}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   endIcon="far fa-plug"
				   [loading]="integrationActionInProcess"
				   (action)="connectToGsuite();">
				{{isConnected() ? 'Disconnect' : 'Connect'}}
			</btn-c>
		</div>
	</div>

	<!--Advanced Permissions-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Advanced Permissions</span>
			<span style="font-size: 12px; max-width: 300px;">Required permissions for disabling user accounts and resetting user passwords in Google Workspace via Account Takeover Protection</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;" endIcon="far fa-plug" *ngIf="!planInfo.gsuite_server.advanced_enabled"
				   [isDisabled]="integrationActionInProcess || !isConnected()"
				   [loading]="integrationActionInProcess"
				   (action)="gsuiteAdvancedPopup = {show: true}">
				Grant Advanced Permissions
			</btn-c>

			<div class="flex-column gap-2" *ngIf="planInfo.gsuite_server.scopes?.includes('users_modify')">
				<span style="color: green;">Granted</span>
			</div>
		</div>
	</div>

	<!--Domains-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Domains</span>
			<span style="font-size: 12px; max-width: 300px;">Domains managed by your Google Workspace server</span>
		</div>
		<div class="w-50">
			<div *ngFor="let domain of planInfo.gsuite_server.verified_domains">
				- {{domain}}
			</div>
			<span class="text-muted flex-row align-items-center h-100" *ngIf="!planInfo.gsuite_server.verified_domains?.length">No verified domains</span>
		</div>
	</div>

	<!--Verify connection-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Verify connection</span>
			<span style="font-size: 12px; max-width: 300px;">Click to verify your integration is configured correctly</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   [isDisabled]="integrationActionInProcess || !isConnected()"
				   (action)="verifyGsuiteIntegration();">
				Verify
			</btn-c>
		</div>
	</div>

	<!--Groups/Aliases-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Groups/Aliases</span>
			<span style="font-size: 12px; max-width: 300px;">Knowing your groups/aliases will allow us to protect you better</span>
		</div>
		<div class="w-50 flxRow" style="flex-wrap: wrap; align-items: flex-start;">
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getGroups(true);">
				Show Groups
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getMailboxesAliases(true);">
				Show Aliases
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   [loading]="integrationActionInProcess"
				   endIcon="{{integImportGroupsSummary ? 'far fa-sync': 'far fa-users-cog'}}"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   (action)="integImportGroups();">
				Sync
			</btn-c>
		</div>
	</div>

	<!--OAuth scopes-->
	<div class="flex-row gap-4" *ngIf="planInfo.gsuite_server.scopes?.length">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">OAuth scopes</span>
			<span style="font-size: 12px; max-width: 300px;">OAuth scopes grant Trustifi permission to access specific data and functionality within your Google Workspace tenant</span>
		</div>
		<div class="w-50">
			{{planInfo.gsuite_server.scopes.join(', ')}}
		</div>
	</div>

</div>

<!--GSuite config popup-->
<popup-c *ngIf="gsuiteConfigPopup?.show"
		 head="Configure Google Workspace" size="large"
		 (closeCb)="gsuiteConfigPopup = null;"
		 (confirmCb)="connectGSuite();"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Connect', loading: integrationActionInProcess}}">
	<div class=" flxClmn f-1-0" style="overflow: auto;">
		<span style="font-size: 16px;">Manually configure a connection with Google Workspace&nbsp;&nbsp;*</span>
		<br/><br/>
		<div class="flxClmn f-1-0" style="overflow: auto; background: rgba(0,0,65,0.007);">
			<p style="line-height: 1.45rem; margin-block-end: 0;">
				Please follow instructions below :<br/>
				1. Log in to your  <a style="color: cornflowerblue; font-weight: bold;" href="https://admin.google.com/">Google Admin Console</a>. <br/>
				2. Click on <strong>Security</strong> <span style="font-weight: 700; margin: 0 2px; color: lightslategrey;">❯</span> <strong>API Controls</strong>.<br/>
				3. Click on the link <strong>Manage Domain Wide Delegation</strong> at the bottom of the page.<br/>
				4. In <strong>API Clients</strong> table, Click on <strong>Add New</strong>.<br/>
				5. Copy the following code and paste it in <strong>Client ID</strong> input area :
			</p>
			<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
				<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: center;" class="flxClmn-center">
					<span style="font-weight:500; overflow: auto; width: 100%; text-align: center;" class="hide-scrollbar click-select-all">
						{{planInfo.googleAdminAppId}}
					</span>
				</div>
				<a (click)="copyText(planInfo.googleAdminAppId);">
					<i class="far fa-copy copy-link" tooltip="Copy client ID"></i>
				</a>
			</div>
			<p style="line-height: 1.45rem; margin: 0;">
				6. Copy the following text and paste it in <strong>OAuth scopes</strong> input area :
			</p>
			<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
				<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: flex-start; padding: 0 10px;" class="flxClmn-center">
					<span style="font-weight:500; overflow: auto; width: 100%;" class="hide-scrollbar click-select-all">
						{{googleScopesLine}}
					</span>
				</div>
				<a (click)="copyText(googleScopes);">
					<i class="far fa-copy copy-link" tooltip="Copy scopes"></i>
				</a>
			</div>
			<p style="line-height: 1.45rem; margin: 0;">
				7. Optional: Add this scope to provide advanced control over user accounts for the Account Compromise Detection service
			</p>
			<div style="align-items: center; margin:7px 15px;" class="flxRow-start hSpace2">
				<div style="font-size: 16px; width: 45%; background: #bac9d642; height: 30px; align-items: flex-start; padding: 0 10px;" class="flxClmn-center">
					<span style="font-weight:500; overflow: auto; width: 100%;" class="hide-scrollbar click-select-all">
						{{googleScopeActivity}}
					</span>
				</div>
				<a (click)="copyText(googleScopeActivity);">
					<i class="far fa-copy copy-link" tooltip="Copy scopes"></i>
				</a>
			</div>
			<p style="line-height: 1.45rem; margin: 0;">
				8. Click <strong>Authorize</strong>.<br/><br/>
				To get your Entity ID :<br/>
				1. Go back again to <a style="color: cornflowerblue; font-weight: bold;" href="https://admin.google.com/">Google Admin Console</a> home page.<br/>
				2. Click on <strong>Security</strong> <span style="font-weight: 700; margin: 0 2px; color: lightslategrey;">❯</span> <strong>Set up single sign-on (SSO) for SAML applications</strong>.<br/>
				3. Copy the last part of the <strong>Entity ID</strong> URL.<br/>
				Example:
				<span style="background: #bac9d642; align-items: center; display: inline-block; margin: 5px; padding: 2px 8px;" class="flxClmn-center">
					<span style="" class="hide-scrollbar">https://accounts.google.com/o/saml2?idpid=</span>
					<span style="color: #ec407a; font-weight: 600;" class="hide-scrollbar">XXXXXXXXX</span>
					<span style="opacity: 0.6; font-size: 12px;" class="hide-scrollbar">&nbsp;&nbsp;⬅ your client ID</span>
				</span>
			</p>
		</div>
		<hr style="margin:0;"/>
		<div class="flxRow"></div>
		<a target="_blank" rel="noopener noreferrer" href="https://docs.trustifi.com/docs/google-workspaces">
			<span style="float: right; color: cornflowerblue; margin: 6px 5px;">
				For a full guide with screenshots click here
			</span>
			<span style="font-size: 16px; color: cornflowerblue; float: right; margin-top: 6px;">*</span>
		</a>
		<br/>
		<span>Enter your email and the Entity ID you copied before and click <b>Connect</b></span>
		<br/>
		<div>
			<table class="simpleDataTableShrink middle">
				<tr>
					<td>
						<span>Admin Email :</span>
					</td>
					<td>
						<input style="width:200px;" type="text"
							   [ngClass]="{'validation-error' : gsuiteConfigPopup.inputErrors.gsuiteAdminEmail}"
							   [(ngModel)]="gsuiteConfigPopup.gsuiteAdminEmail">
					</td>
				</tr>
				<tr>
					<td>
						<span>Entity ID :</span>
					</td>
					<td>
						<input style="width:200px;" type="text"
							   [ngClass]="{'validation-error' : gsuiteConfigPopup.inputErrors.idInput}"
							   [(ngModel)]="gsuiteConfigPopup.gsuiteCustomerId">
					</td>
				</tr>
			</table>
		</div>
		<hr/>
	</div>
</popup-c>

<!--GSuite advanced scope popup-->
<popup-c class="bs-enabled" *ngIf="gsuiteAdvancedPopup?.show"
		 head="Google Workspace Advanced Scope" size="dynamic"
		 (closeCb)="gsuiteAdvancedPopup.show = false; verifyGsuiteScope('users_modify', false)"
		 (confirmCb)="verifyGsuiteScope('users_modify', true)"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Apply', disabled: gsuiteAdvancedPopup.inProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="flex-column gap-2">
			<div>
				<span>
					Add the Auth scope below to grant advanced user-account control capabilities for the Account Takeover Protection service:
				</span>
				<ul>
					<li>Reset user mailbox passwords</li>
					<li>Disable user mailbox accounts</li>
					<li>Monitor user mailbox rules</li>
				</ul>
			</div>

			<div style="align-items: center;" class="flxRow-start hSpace2">
				<div style="font-size: 15px; cursor: pointer; background: #bac9d642; height: 30px; align-items: flex-start; padding: 0 10px;" class="flxClmn-center">
					<span style="font-weight:500; overflow: auto; width: 100%;" class="hide-scrollbar click-select-all" (click)="copyText(googleScopeActivity);">
						{{googleScopeActivity}}
					</span>
				</div>
				<a (click)="copyText(googleScopeActivity);">
					<i class="far fa-copy copy-link" tooltip="Copy scope"></i>
				</a>
			</div>

			<div style="margin-top: 15px;">
				After adding the scope in Google, click on the "Apply" button
			</div>

		</div>
	</div>
</popup-c>


<groups-popup-c
	*ngIf="showGroups"
	(cancelCb)="showGroups = false"
	[showActions]="true"
	[popupTitle]="'Groups'">
</groups-popup-c>

<aliases-popup-c *ngIf="showAliases"
                 (cancelCb)="getMailboxesAliases(false)"
                 [popupTitle]="'Mailboxes Aliases'"
                 [showActions]="true">
</aliases-popup-c>
